import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const InstagramMarketing = () => {
  const relatedBlogs = [
    {
      id: 3,
      title: 'Top 10 Social Media Marketing Strategies for Doctors in 2026',
      image: '/images/Blog2.png',
      date: 'January 28, 2026'
    },
    {
      id: 1,
      title: 'How to Optimize Your Medical Practice Website for Local SEO in 2026',
      image: '/images/Blog4.png',
      date: 'February 3, 2026'
    },
    {
      id: 12,
      title: 'Healthcare Content Marketing: How to Educate and Engage Your Patients',
      image: '/images/Blog14.png',
      date: 'January 8, 2026'
    }
  ];

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1611605698335-8b1569810432?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            Instagram Marketing for Medical Practices
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <Link 
              to="/blog" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Blog
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Instagram Marketing
            </span>
          </motion.div>
        </div>
      </section>

      {/* SECTION 1: TWO-COLUMN WITH SIDEBAR */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8">
            
            {/* LEFT SIDE - Intro Content */}
            <div className="lg:col-span-8">
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="mb-8"
              >
              <img 
  src="/images/Blog7.png" 
  alt="Instagram Marketing for Medical Practices"
  className="w-2/3 mx-auto rounded-xl object-contain"

 />

              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#19354a] mb-6"
              >
                Instagram Marketing for Medical Practices: The 2026 Playbook
              </motion.h1>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="flex flex-wrap items-center gap-4 text-sm text-[#19354a] mb-8 pb-6 border-b-2 border-gray-200"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                  <span>Docmize Team</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Published : January 15, 2026</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Last Updated : January 15, 2026</span>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  Instagram has become one of the most powerful platforms for medical practices to connect with patients, build brand awareness, and showcase their expertise. With over 2 billion monthly active users in 2026, Instagram offers healthcare providers unprecedented opportunities to engage with current and prospective patients through visual storytelling, educational content, and authentic community building.
                </p>

                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  This comprehensive playbook guides medical practices through every aspect of Instagram marketing, from profile optimization and content strategy to Reels creation and patient engagement. Whether you're just starting on Instagram or looking to enhance your existing presence, these proven strategies will help you build a loyal patient community and grow your practice.
                </p>
              </motion.div>

            </div>

            {/* RIGHT SIDE - Sidebar */}
            <motion.aside 
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="lg:col-span-4"
            >
              <div className="sticky top-24">
                
                <div className="bg-white rounded-2xl border-2 border-[#19354a] p-6 mb-6">
                  <h3 className="text-xl font-bold text-[#19354a] mb-6 pb-4 border-b-2 border-gray-200">
                    Categories
                  </h3>
                  <div className="space-y-2">
                    {['Social Media', 'Digital Marketing', 'Content Marketing', 'Patient Acquisition', 'Healthcare Technology', 'Web Development', 'SEO', 'Online Reputation Management'].map((category, index) => (
                      <Link
                        key={index}
                        to="/blog"
                        className="w-full text-left px-4 py-3 rounded-lg font-medium transition-all bg-gray-50 text-gray-700 hover:bg-[#19354a] hover:text-white block"
                      >
                        <div className="flex items-center justify-between">
                          <span>{category}</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#19354a] to-[#0f2133] rounded-2xl p-6 text-white">
                  <h3 className="text-xl font-bold mb-4">
                    Need Help with Instagram Marketing?
                  </h3>
                  <p className="text-white/80 mb-6 text-sm leading-relaxed">
                    Get expert social media strategies tailored to your medical practice.
                  </p>
                  <Link 
                    to="/contact"
                    className="block w-full text-center px-6 py-3 bg-[#39a5d3] text-white rounded-lg font-semibold hover:bg-white hover:text-[#19354a] transition-all"
                  >
                    Get Free Consultation
                  </Link>
                </div>

              </div>
            </motion.aside>

          </div>
        </div>
      </section>

      {/* SECTION 2: FULL WIDTH CONTENT */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Setting Up Your Medical Practice Instagram Profile
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Your Instagram profile serves as the digital front door to your medical practice. Optimize your profile with a professional photo, clear practice name, comprehensive bio highlighting your specialties and services, and clickable links to your website or booking page. Switch to a professional business account to access analytics, contact buttons, and advertising features.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Include relevant keywords in your bio, add your location and contact information, create Story Highlights showcasing different aspects of your practice, and maintain consistent branding across profile picture, bio, and content. Use Instagram's business tools to add appointment booking, email, and phone call buttons directly to your profile.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Creating Engaging Instagram Content
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Successful medical practice Instagram content balances education, engagement, and authenticity. Share patient education content, health tips, behind-the-scenes practice tours, staff introductions, patient success stories (with consent), and community involvement. Use high-quality images and videos that reflect your practice's personality while maintaining professionalism.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Develop a content calendar with diverse post types including educational carousels, before-and-after photos (where appropriate), patient testimonials, staff spotlights, health awareness campaigns, and interactive polls or quizzes. Maintain HIPAA compliance by never posting patient information without explicit written consent and avoiding any identifiable medical details.
            </p>

            <h3 className="text-xl sm:text-2xl font-bold text-[#19354a] mb-4 mt-6">
              Instagram Content Ideas for Medical Practices
            </h3>

            <ul className="list-disc list-inside text-gray-900 text-base leading-relaxed mb-6 space-y-2 ml-4 text-justify">
              <li>Educational posts about common health conditions and treatments</li>
              <li>Quick health tips and wellness advice</li>
              <li>Meet the team posts highlighting staff expertise</li>
              <li>Patient success stories and testimonials</li>
              <li>Behind-the-scenes look at your practice</li>
              <li>Community health events and initiatives</li>
              <li>Myth-busting posts about medical misconceptions</li>
              <li>Seasonal health awareness content</li>
            </ul>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Mastering Instagram Reels for Healthcare
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Instagram Reels have become the platform's most powerful feature for organic reach and engagement. Create short, engaging video content that educates, entertains, and connects with your audience. Use trending audio (when appropriate), add captions for accessibility, and focus on providing value in 15-60 second videos.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Develop Reels content around common patient questions, treatment explanations, health myth debunking, day-in-the-life practice tours, quick health tips, and provider introductions. Keep videos authentic and personable while maintaining professional standards. Use hooks in the first 2 seconds to capture attention and include clear calls-to-action.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Leveraging Instagram Stories
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Instagram Stories provide opportunities for real-time engagement and behind-the-scenes content. Share daily practice updates, quick health tips, Q&A sessions, polls about health topics, countdown timers for events, and links to blog posts or booking pages. Stories create urgency and authenticity that resonates with followers.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Use interactive features like polls, questions, quizzes, and sliders to boost engagement. Create Story Highlights to preserve valuable content for new visitors, organizing them by topics such as Services, Team, Patient Reviews, Health Tips, and FAQs. Post Stories consistently to stay top-of-mind with your audience.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Building and Engaging Your Community
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Community engagement drives Instagram success for medical practices. Respond promptly to comments and direct messages, engage with local businesses and health organizations, participate in relevant conversations, and acknowledge patient interactions (following HIPAA guidelines). Building genuine relationships creates loyal followers who become practice advocates.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Use strategic hashtags combining branded, local, and industry-specific tags. Collaborate with local influencers, partner with complementary healthcare providers, and participate in health awareness campaigns. Tag locations in posts to increase local visibility and attract nearby patients searching for healthcare services.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Instagram Advertising for Patient Acquisition
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Instagram ads amplify your organic efforts and target specific patient demographics. Create compelling ad campaigns promoting services, special offers, educational content, or appointment booking. Use Instagram's detailed targeting options to reach patients by location, age, interests, and behaviors relevant to your specialties.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Design visually appealing ads with clear calls-to-action, test different formats including image ads, video ads, carousel ads, and Story ads, and track performance metrics to optimize campaigns. Ensure all advertising complies with healthcare marketing regulations and platform policies while driving measurable patient acquisition results.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Measuring Instagram Success
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Track Instagram performance using built-in analytics and third-party tools. Monitor follower growth, engagement rates, reach and impressions, profile visits, website clicks, and appointment bookings from Instagram. Analyze which content types perform best, optimal posting times, and demographic insights about your audience.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Set specific goals for Instagram marketing including follower milestones, engagement targets, and conversion metrics. Regularly review analytics, adjust your strategy based on data, and continuously test new content approaches. Successful Instagram marketing requires ongoing optimization and adaptation to platform changes and audience preferences.
            </p>

            {/* FAQ SECTION */}
            <div className="mt-12 mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-8 text-center">
                Frequently Asked Questions (FAQs)
              </h2>

              <div className="space-y-4">
                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How often should medical practices post on Instagram?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Aim for 3-5 feed posts per week plus daily Stories. Consistency matters more than frequency. Focus on quality content that provides value rather than posting frequently with lower-quality content. Reels should be posted 2-3 times per week for optimal reach.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Can I share patient photos on Instagram?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Only share patient photos with explicit written consent that specifically authorizes social media use. Ensure all content complies with HIPAA regulations. Never share identifiable medical information or before-and-after photos without proper authorization and releases.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      What types of hashtags should medical practices use?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Use a mix of branded hashtags (#YourPracticeName), local hashtags (#CityNameDoctor), specialty-specific hashtags (#Dermatology, #FamilyMedicine), and health topic hashtags (#SkinCareTips). Limit to 10-15 relevant hashtags per post and avoid overly generic tags.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Should I respond to medical questions in Instagram comments?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Provide general educational information but never give specific medical advice on social media. Direct people to schedule appointments for personalized medical guidance. Include disclaimers that social media interactions don't establish doctor-patient relationships and aren't substitutes for professional medical advice.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How can Docmize help with Instagram marketing?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Docmize specializes in healthcare social media marketing with proven Instagram strategies for medical practices. We handle profile optimization, content creation, Reels production, community management, advertising campaigns, and performance tracking. Our healthcare expertise ensures HIPAA-compliant, engaging content that builds your patient community.
                  </div>
                </details>
              </div>
            </div>

          </motion.div>
        </div>
      </section>

      {/* RELATED BLOGS SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl font-bold text-[#19354a] mb-8"
          >
            Related Blog
          </motion.h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {relatedBlogs.map((blog, index) => (
              <motion.article
                key={blog.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#19354a] mb-3 line-clamp-2">
                    {blog.title}
                  </h3>
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    <span>{blog.date}</span>
                  </div>
                  <Link 
                    to="/blog"
                    className="inline-flex items-center gap-2 text-[#39a5d3] font-semibold hover:gap-3 transition-all"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default InstagramMarketing;